const en = {
  appName: "Socialbility",
  welcome: "Hello",
  continue: "Continue",
  default: "Default (Paragraph Small Regular Text)",
  h1Large: "H1 Large Text",
  h1Medium: "H1 Medium Text",
  h1Small: "H1 Small Text",
  h1XSmallExtraBold: "H1 XSmall Extra Bold Text",
  h1XSmallBold: "H1 XSmall Bold Text",
  h2LargeBold: "H2 Large Bold Text",
  h2LargeSemiBold: "H2 Large SemiBold Text",
  h2MediumBold: "H2 Medium Bold Text",
  h2MediumSemiBold: "H2 Medium SemiBold Text",
  h2SmallBold: "H2 Small Bold Text",
  h2SmallSemiBold: "H2 Small SemiBold Text",
  h3Large: "H3 Large Text",
  h3Small: "H3 Small Text",
  h3XSmall: "H3 XSmall Text",
  h4Large: "H4 Large Text",
  h4SmallSemiBold: "H4 Small SemiBold Text",
  h4SmallMedium: "H4 Small Medium Text",
  paragraphXSmallMedium: "Paragraph XSmall Medium Text",
  paragraphSmallRegular: "Paragraph Small Regular Text",
  paragraphSmallMedium: "Paragraph Small Medium Text",
  paragraphMediumRegular: "Paragraph Medium Regular Text",
  paragraphMediumSemiBold: "Paragraph Medium SemiBold Text",
  loginOrCreateAccount: "Log in or Create Account",
  or: "or",
  continueWithGoogle: "Continue with Google",
  continueWithFacebook: "Continue with Facebook",
  continueWithApple: "Continue with Apple",
  login: "Log in",
  loginNavbar: "Login",
  forgotYourPassword: "Forgot your password?",
  alreadyHaveAnAccount: "Already have an account?",
  createAccount: "Create account",
  yourPasswordShouldContain: "Your password should contain:",
  atleast6Characters: "At least 6 characters",
  atleast1NumberOrUppercaseLetter: "1 symbol or number",
  agreeAndContinue: "Agree and continue",
  saveAndContinue: "Save and continue",
  howWillYouUseSociability: "How will you use Sociability?",
  helpUsImproveYourExperience: "Help us improve your experience",
  chooseOne: "Choose one",
  back: "Back",
  howDidYouFindOutAboutSociability: "How did you find out about Sociability?",
  selectAllThatApply: "Select all that apply.",
  createYourAccessibilityProfile: "Create your accessibility profile",
  findThePlacesThatWorkForYou: "Find the places that work for you!",
  doYouWantToMakeYourDisabilityVisibleToTheSociabilityCommunity:
    "Would you like to show other Sociability users your accessibility needs?",
  makeDisabilityVisible: "Make disability visible?",
  youCanChangeThisAnytimeInYourAccountSettings:
    "You can change this anytime in your account settings",
  whatAccessibilityFeaturesDoYouRequire:
    "What accessibility features do you prefer?",
  areAnyOfTheseSuitable: "Are any of these suitable?",
  letsVerifyYourEmailAddress: "Let's verify your email address",
  weJustNeedToCheckTtsReallyYou: "We just need to check it's really you:",
  wehaveJustSentAnEmailTo: "We've just sent an email to:",
  clickTheLinkInsideToLogInToSociability:
    "Check your inbox for the verification email to continue",
  returnToLoginPage: "Log in to Sociability",
  getInTouch: "Get in touch",
  letUsKnowYourFeedback: "Let us know your feedback:",
  send: "Send",
  addPhotos: "Add photos",
  addPhoto: "Add photo",
  exitMenu: "Exit menu",
  preferences: "Preferences",
  yourProfile: "Your account",
  locationPreferences: "Location preferences",
  yourAccessibilityProfile: "Your accessibility profile",
  accessibilityFeatures: "Accessibility features",
  appAccessibility: "App accessibility",
  deviceSettings: "Device settings",
  helpSupport: "Help & Support",
  howTheAppWorks: "How the app works",
  taggingInformation: "Tagging information",
  faqs: "FAQs",
  aboutSociability: "About sociability",
  appFeedback: "App feedback",
  finePrint: "Fine print",
  privacyPolicy: "Privacy policy",
  termsOfUse: "Terms of use",
  logOut: "Log out",
  resetPassword: "Reset password",
  enterYourNewPasswordAndConfirmItBelow:
    "Enter your new password and confirm it below",
  doYouOrSomeoneYouKnowHaveAnyAccessibilityRequirements:
    "Do you or someone you know have any accessibility requirements?",
  skipForNow: "Skip for now",
  tellUsABitAboutYourself: "Tell us a bit about yourself",
  doYouOrSomeoneYouKnowExperienceOrUseAnyOfTheFollowing:
    "Do you or someone you know experience or use any of the following?",
  shareYourAccessibilityProfile: "Share your accessibility profile",
  tellTheCommunityABitMoreAboutYourself:
    "Tell the community a bit more about yourself.",
  helpOtherUsersBetterUnderstandYourReviews:
    "This helps other users find venue reviews that are most relevant to them",
  setYourPreferredFilters: "Set your preferred filters",
  selectAllThatApply2:
    "Select all that apply. Change these anytime in your user profile.",
  wouldAnyOfTheseAlsoWork: "Would any of these also work?",
  cancel: "Cancel",
  close: "Close",
  takePhoto: "Take photo",
  fromPhotos: "From photos",
  termsAndConditions: "Terms and conditions",
  byClickingAgree:
    "To use Sociability, please review and agree to our terms. These outline how the app works and how your information is handled.",
  reviewOnboarding: "Review onboarding",
  searchVenueOrLocation: "Search venue or location",
  showNearBy: "Show nearby",
  filters: "Filters",
  listview: "List view",
  finish: "Finish",
  venueTypes: "Venue types",
  openingHours: "Opening hours",
  search: "Search",
  clearAll: "Clear all",
  showMore: "Show more",
  showLess: "Show less",
  youAreInTaggingMode: "You're in Tagging mode!",
  taggingModeDescription1:
    "You can now only see venues without accessibility information.",
  taggingModeDescription2:
    "Continue to tag the accessibility of new venues, or return to exploring venues below.",
  gotItLetsTag: "Got it. Let's tag!",
  switchBackToExploring: "Switch back to exploring venues",

  youAreInExploregMode: "You're in Explore mode!",
  homeModeDescription1:
    "You can now only see all venues - with and without accessibility information.",
  homeModeDescription2:
    "Continue to explore new venues, or return to tagging venues below.",
  gotItLetsExplore: "Got it. Let's explore!",
  switchBackToTagging: "Switch back to tagging venues",
  accessibilityOverview: "Accessibility Overview",
  completedSections: "Completed Sections",
  addAccessibilityInfo: "Add accessibility info",
  viewAllInformation: "View All Information",
  isSomethingNotRight: "Is something not right?",
  reportAnErrorOrUpdate: "Report an error or update",
  sortBy: "Sort by",
  photos: "Photos",
  reviews: "Reviews",
  addReview: "Add review",
  addAccessibilityInformation: "Add accessibility information",
  addAReview: "Add a review",
  thisVenueIsLookingBare: "This venue is looking bare...",
  addPhotosAndTagsToShare:
    "Add photos and tags to share accessibility information with others!",
  mapperNotes: "Mapper notes",
  tellOtherMappersAbout: "Tell other mappers about your experience",
  submit: "Submit",
  leaveReview: "Leave a review",
  didThisVenueSuitYourNeeds: "Did this venue suit your accessibility needs?",
  howWasYourVisitToThisVenue: "How was your visit to this venue?",
  post: "Post",
  whatIsThisPhotoOf: "What is this photo of?",
  brieflyDescribeThisPhoto:
    "Describe this photo for those who might not be able to see it. At least 5 characters are required.",
  yes: "Yes",
  no: "No",
  describeWhatThisImageShows:
    "Describe what this image shows to help our blind users.",
  pleaseSelectOneOfTheTags: "Please select one of the tags.",
  adddMorePhotos: "Add more photos",
  upload: "Upload",
  areYouSureYouWantToRemoveThisPhotoFromYourUpload:
    "Are you sure you want to remove this photo from your upload? you will lose any alt text added.",
  removePhoto: "Remove photo?",
  wereSorryThisVenueHasNoReviews:
    "We're sorry! This venue has no reviews yet. Get us started by adding one now!",
  photosUploadedSuccessfully: "Photos uploaded successfully!",
  reviewUploadedSuccessfully: "Review uploaded successfully!",
  startTagging: "Let's start tagging!",
  pickACategory:
    "Provide accessibility information by uploading photos and answering a few questions.",
  finishTagging: "Finish tagging",
  pickAnAreaToTag: "Select an area",
  pickAnAreaToTagLong:
    "Pick an area of the venue to tag! You’ll need to start with the Main Entrance, but after that you can return to choose any of the others.",
  locked: "Locked",
  editInformation: "Edit information",
  gettingStarted: "Getting started",
  dontShowThisAgain: "Don't show this to me again",
  uploadPhotosFromYourGallery:
    "Upload photos from your gallery or take new ones right now.",
  uploadPhotos: "Upload photos",
  thenAddShortDescription:
    "Then add a short description of each photo for screen reader users.",
  describeThisPhoto: "Describe this photo",
  brieflyDescribeThisPhotoYouHaveAdded:
    "Briefly describe each photo you have added for our low-vision or blind users.",
  thisIsAPhotoOf: "This is a photo of....",
  describeThisPhotoForOurBlindUsers: "Describe this photo",
  exit: "Exit",
  nextPhoto: "Next photo",
  photosAdded: "Photos added!",
  managePhotos: "Manage photos",
  toViewSimplyTap:
    "To view, simply tap a picture. If you want to reorder just drag the photos. Alternatively, you can add more photos if you like. You must upload at least one photo.",
  next: "Next",
  assignTags: "Assign tags",
  answerEachQuestionToTag:
    "Answer each question to add accessibility information to this venue for other users. Use your photos to help jog your memory.",
  areYouSure: "Are you sure?",
  ifYouLeaveThisScreenYouWillLose:
    "If you leave this screen you will lose your current photos. Click exit to start again or click continue to keep your current photos.",
  deletePhoto: "Delete photo",
  areYouSureYouWantToDeleteThisPhoto:
    "Are you sure you want to delete this photo? It will make changes to the venue.",
  selectAllApply: "Select all that apply",
  chooseOneAnswer: "Choose one answer",
  areYouSureYouWantToStopTagging: "Are you sure you want to stop tagging?",
  yourProgressWillBeSavedAndYouCanReturn:
    "Your progress will be saved and you can return to finish the area later.",
  pleaseCompleteAllRequiredQuestions:
    "* Please complete all required questions.",
  error: "Error",
  userNotLoggedIn: "User not logged in",
  updateTags: "Update tags",
  isThereAnythingThatNeedsToBeUpdated:
    "Is there anything that needs to be updated? Make sure all accessibility information is accurate and up-to-date.",
  editPhotos: "Edit photos",
  thanksForCheckingTags:
    "Thanks for updating your tags! Would you also like to check your photos to ensure they match?",
  ItsImportantToEnsureThatYourPhotosAreAccurate:
    "It's important to ensure that the photos match the tags so that our information is as accurate as possible for other users.",
  reviewPhotos: "Review photos",
  savePhotos: "Save photos",
  areYouSureYouWantToUpdateAccessibility:
    "Are you sure you want to update the accessibility information? it will make changes to the venue",
  photoGuide: "Photo guide",
  doYouWantToAddAddionalVSHInformation:
    "Do you want to add additional visual, sensory and hearing photos?",
  deleteInformation: "Delete information",
  save: "Save",
  photoWillBePermanentlyDeleted:
    "Photo will be permanently removed from this venue.",
  delete: "Delete",
  selectPhotos: "Select photos",
  atleastOnePhotoIsReq:
    "At least one photo is required for each area. Uncheck at least one photo to continue.",
  deletePhotos: "Delete photos",
  photosWillBePermanentlyDeleted:
    "Photo(s) will be permanently removed from this venue.",
  photosDeleted: "Photos deleted!",
  taggingInProgress: "Tagging in progress",
  thisAreaHasAlreadyBeenTagged:
    "This area has already been tagged. Add a new one!",
  editAccessibilityInformation: "Edit accessibility information",
  settings: "Settings",
  mapperNoteAdded: "Mapper note added!",
  noPhotosHaveBeenAddedToThisVenueYet:
    "No photos have been added to this venue yet. Get us started by adding some now!",
  thereAreCurrentlyNoImagesForVSH:
    "There are currently no images for the Visual, Sensory, and Hearing section. Add some photos or click save to finish editing.",
  thisAreaIsLocked: "This area is locked!",
  reviewSavedSuccessfully: "Review saved successfully",
  addImage: "Add image",
  inviteYourFriendsToJoinYourTeam:
    "Invite your friends to join your team and compete against others to tag the most venues!",
  myTeams: "My teams",
  shareInviteFriends: "Share & invite friends",
  shareTheSociabilityApp: "Share the Sociability App",
  askYourFriendToScan:
    "Ask your friend to scan this QR code or share via email or text",
  shareViaEmailOrText: "Share a link",
  shareUserProfile: "Share your user profile",
  inviteYourFriendsToJoinYourTeam2: "Invite friends to join your team",
  selectATeam: "Select a team",
  createTeam: "Create team",
  yourTeamName: "Your team name",
  enterYourTeamName: "Enter your team name",
  create: "Create",
  teamMembers: "Team members",
  addNewMember: "Add new member",
  noTeamMembers: "No team members",
  addNewMembersToYourTeamBy: "Add new member to your team",
  renameTeam: "Rename team",
  updateCoverPhoto: "Update cover photo",
  deleteTeam: "Delete team",
  areYouSureYouWantToDeleteThisTeam:
    "Are you sure you want to delete this team?",
  addTeamMember: "Add team member",
  askYourFriendToScanThis:
    "Ask your friend to scan this QR code or send via email or text.",
  viewProfile: "View profile",
  removeUser: "Remove team member",
  teamMemberProfileSetToPrivate: "Team member profile set to private",
  removeMember: "Remove member",
  areYouSureYouWantToRemoveThisMember:
    "Are you sure you want to remove this member?",
  flagUser: "Flag user",
  blockUser: "Block user",
  reportAnIssueWithAnotherUser: "Report an issue with another user",
  desribeTheIssueWithThisUserAndAddScreenshots:
    "Describe the issue with this user and add any screenshots that might help explain your information.",
  share: "Share",
  editReview: "Edit review",
  editPhotos: "Edit photos",
  deleteReview: "Delete review",
  aSociabilityAdminHasEditedTheseTags:
    "These tags have been updated by a Sociability Admin.",
  continueTaggingQuestion: "Continue tagging?",
  continueTagging: "Continue tagging",
  iWilldoItLater: "I'll do it later",
  leaveTeam: "Leave team",
  earnPointsByAddingTagsDesc:
    "Earn points by adding tags, reviews and photos for venues. Earn special badges to get an extra boost and you move up the leaderboard!",
  areYouSureYouWantToLeaveThisTeam: "Are you sure you want to leave this team",
  explore: "Explore",
  mySavedPlaces: "My saved places",
  basicInfo: "Basic Information",
  fullName: "Full name",
  edit: "Edit",
  email: "Email",
  gender: "Gender",
  yearOfBirth: "Year of birth",
  password: "Password",
  changePassword: "Change password",
  privacySettings: "Privacy settings",
  shareYourProfileActivity: "Profile activity",
  profileVisibility: "Make your profile activity visible to other users",
  makeYourDisabilityVisibleInreviews:
    "Make your disability visible in venue reviews",
  yourAccessibilityProfile: "Your accessibility profile",
  yourAccessRequirements: "Your access requirements",
  yourSavedFilters: "Your saved filters",
  updateProfile: "Update Profile",
  update: "Update",
  saveChanges: "Save changes",
  emailAndPassword: "Email & Password",
  filtersWillDisplayVenuesWithYour:
    "Filters will display venues with your preferred accessibility features.",
  account: "Account",
  deleteYourAccount: "Delete your Account",
  yourAccountWillBeDeleted:
    "Your account will be deleted, this action cannot be undone.",
  chooseAGender: "Pick a gender",
  pickYearOfBirth: "Pick year of birth",
  updatePassword: "Update password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  areYouSureYouWantToDeleteThisAccount:
    "Are you sure you want to delete this account?",
  deleteAccount: "Delete account",
  confirmProfilePhoto: "Confirm profile photo",
  enterYourExistingPwd: "Enter your existing password",
  createAStrongPwd: "Create a strong password",
  confirmYourNewPwd: "Confirm your new password",
  passwordMatches: "Passwords match",
  passwordsDontMatchPleaseTryAgain:
    "Passwords don't match, please check and try again",
  yourPwdShouldContain: "Your password should contain: ",
  atLeast6Chars: "At least 6 characters",
  oneSymbolOrNumber: "One symbol or number",
  updateEmail: "Update email",
  passwordShouldContain:
    "Password should contain at least 6 characters, one symbol or number",
  closedToday: "Closed Today",
  invalidTime: "Invalid Time",
  accessibilityInformationAvailable: "Accessibility information available",
  noAccessibilityInformationAvailable: "No accessibility information available",
  lastUpdated: "Last updated",
  allPhotos: "All photos",
  allReviews: "All reviews",
  continueWithApple: "Continue with Apple",
  makeYourDisabilityPublic: "Make your disability public?",
  youCanChangeThisAnytimeInYourUserProfile:
    "You can change this anytime in your user profile.",
  bySelectingAgreeAndContinue:
    "I confirm that I have read, understood and accept the",
  and: "and",
  privacyNotice: "privacy notice",
  loading: "Loading...",
  downloadApp: "Download App",
  searchForVenue: "Search for a venue",
  typeAVenueNameOrLocation: "Type a venue name or location",
  yourProfile: "Your profile",
  yourActivity: "Your activity",
  applySavedAccessibilityFilters: "Apply saved accessibility filters",
  applyFilters: "Apply filters",
  openNow: "Open now",
  signInWithApple: "Sign in with Apple",
  showMore: "Show more",
  showLess: "Show less",
  teamNameLengthError: "Team name must have at least 3 characters",
  mySavedPlaces: "My Saved Places",
  allSavedPlaces: "All saved places",
  deleteThisList: "Delete this list?",
  deleteListMessage:
    "This list and all its venues will be removed from your saved places. This action cannot be undone.",
  willBePermanentlyDeletedFromSavedPlaces:
    "will be permanently deleted from your saved places.",
  sort: "Sort",
  deleteFromList: "Delete from list?",
  areYouSureYouWantToDeleteThisFromList:
    "Are you sure you want to delete this place from your list? It will also be deleted from the All Saved Places list.",
  done: "Done",
  youHaventSearchedForAnyPlacseYet: "You haven’t saved any places yet",
  clickOnTheHeartIcon:
    "Click on the heart icon when viewing a place to save it to a list.",
  startANewSearch: "Start a new search",
  createList: "Create list",
  yourListName: "Your list name",
  enterYourListName: "List name",
  addedToYourSavedPlaces: "New list has been added",
  addToSavedPlaces: "Add to saved places",
  createANewList: "Create a new list",
  pleaseSelectAList: "Please select a list",
  bitLostMessageSearch:
    "Looks like we’re a bit lost! Try tweaking your search by adding in more details about the venue name, type or address you’re looking for",
  noMatches: "No matches",
  tryUpdateFilters: "Try changing or removing some of your filters",
  updateFilters: "Update filters",
  ProfileAndPreferences: "Profile & preferences",
  privacy: "Privacy",
  shareYourDisability: "Help the community understand your unique perspective",
  seeAllLevelsBadges: "See all Levels & Badges",
  recentActivity: "Recent activity",
  deletedFromList: "Saved venue deleted from list",
  listCoverPhotoUpdated: "List cover photo updated",
  renameSavedList: "Rename list",
  rename: "Rename",
  listRenamed: "List renamed",
  forgotPassword: "Forgot password",
  updateAccessibilityFilters: "Update accessibility filters",
  profileAcessibilityUpdated: "Profile acessibility have been updated.",
  areYouSureYouWantToDeleteInformationTagging:
    "Are you sure you want to delete information for this area? Information will be deleted permanently.",
  deleteArea: "Delete area",
  shareVenue: "Share venue",
  downloadTheSociabilityApp: "Download the Sociability app!",
  helloCheckOutSociability:
    "Hello! Check out Sociability - a great app I use to find accessible places",
  seeThisSociabilityVenue: "See this Sociability venue!",
  helloCheckoutThisVenue: "Hello! Check out this venue on Sociability",
  shareInviteTeamMemberTitle: "Join my Sociability team!",
  shareInviteTeamMemberMsg: "Hello! Join my team on Sociability",
  shareUserProfileTitle: "See my Sociability profile!",
  shareUserProfileMessage: "Hello! Check out my profile on Sociability",
  shareSavedListTitle: "See my favourite Sociability places!",
  shareSavedListMessage: "Hello! Check out my favourite places on Sociability",
  noActivityFound: "No activity found",
  bitLostMessageActivity:
    "Looks like we're a bit lost! Try tweaking your search by adding in more details about the venue name, type or address you’re looking for",
  chooseADifferentPhoto: "Choose a different photo",
  editProfilePhoto: "Edit profile photo",
  logOut: "Log out",
  areYouSureYouWishToLogOut: "Are you sure you wish to log out?",
  updatePassword: "Update password",
  viewVenues: "View Venue",
  venueAlreadySaved: "Venue already saved",
  joinTeam: "Join team",
  areYouSureYouWantToJoinThisTeam: "Are you sure you want to join this team?",
  pleaseLoginToJoinTeam: "Please login to join a team",
  passwordAtLeast6Chars: "At least 6 characters",
  passwordOneSymbolOrNumber: "One symbol or number",
  mapView: "Map view",
  changesSaved: "Changes saved",
  listView: "List view",
  fullPage: "Full page",
  noSavedFiltersFound: "No saved filters found!",
  deleteReview: "Delete review",
  activityView: "My Activity",
  add: "Add",
  resolveNote: "Resolve Note",
  beforeYouUseSociability: "Before you start",
  checkOutWhatsNearYou: "Check out what's near you!",
  turnOnLocationTrackingHeader:
    "Discover new places, events, and services around you. Enable location tracking to get the most out of your experience.",
  toLetUsLocateYou:
    "To let us locate you on our map and show you nearby places",
  accessToLocationWasDenied:
    "To use this feature, please grant Sociability access to your location!",
  locationDenied: "Location Denied",
  describeYourVisitToThisVenue: "Please describe your visit to this venue",
  delete: "Delete",
  saved: "Saved",
  mustBeLoggedInToSubmitReview: "Must be logged in to submit review",
  yourLocation: "Your Location",
  updateYourDeviceSettings: "Update your device settings",
  allowAccessToCamera: "Allow access to camera",
  allowAccessToPhotos: "Allow access to photos",
  locationTrackingText:
    "To let us locate you on our map and show you nearby places",
  cameraAccessText:
    "So you can take photos when adding accessibility information to venues",
  photosAccessText:
    "So you can attach photos when adding accessibility information to venues",
  camera: "Camera",
  accessToCameraWasDenied:
    "To use this feature, please grant Sociability access to your camera!",
  accessToPhotosWasDenied:
    "To use this feature, please grant Sociability access to your photos!",
  seeMyFavSociabilityPlacesTitle: "See my favourite Sociability places!",
  seeMyFavSociabilityPlacesText:
    "Hello! Check out my favourite places on Sociability",
  seeThisSociabilityVenueTitle: "See this Sociability venue!",
  seeThisSociabilityVenueText: "Hello! Check out this venue on Sociability",
  appAccessibility: "App Accessibility",
  darkMode: "Dark Mode",
  chooseColorMode: "Choose color mode",
  theme: "Theme",
  appAccessibilityTopText:
    "Choose whether to use your device's accessibility settings or customize them specifically for this app. Toggle the switch below to apply app-specific accessibility settings",
  locationSettingsRequired: "Location settings required",
  locationSettingsRequiredText:
    "Please enable your browser’s location settings to find accessible places near you!",
  spottedSomethingWrong: "Spotted something wrong?",
  tellUsWhatInformationNeedsUpdating: "Tell us what information needs updating",
  moreDetailTheBetter: "The more detail the better",
  helpUsCatchEveryError: "Help us catch every error!",
  isThereAnyIncorrectInformationProvided:
    "Is there any incorrect information provided in this review?",
  tellUsWhichTagsAreIncorrect: "Tell us which tags are incorrect",
  tellUsWhyThisPhotoIsIncorrect: "Tell us why this photo is incorrect",
  pleaseClickTaggingTitle:
    "Please click on the boxes below to see detailed content",
  getInTouchPlaceholderText:
    "Please describe the issue you’re having or any feedback you’d like to share...",
  flagIncorrectInformation: "Flag incorrect information",
  tellUsaBitMoreAboutYourself: "Tell us a bit more about yourself",
  addNote: "Add note",
  leaveANoteAboutThisVenue: "Leave a note about this venue",
  characters: "characters",
  verifyThanksMessage:
    "Thanks for verifying! You're now ready to start finding accessible places.",
  noPageFound: "Well this is awkward 😬",
  bitLostMessagePage:
    "The page you are looking for doesn't exist or has been moved. Please go back to the homepage.",
  gotoHomePage: "Go to homepage",
  enterPasswordBelow:
    "Enter your password below to start finding accessible places",
  thanksForEmail:
    "Thanks for your email, please provide more information for: ",
  weCanHelp: "It's okay! We can Help!",
  enterEmailBelowForgot:
    "Enter your email address below and we’ll get you and email to reset your password.",
  profileSetup: "Profile Setup",
  welcomeToSociability: "Welcome to Sociability",
  yourIntroductionToSociability: "Your introduction to Sociability",
  tellUsHowYouFoundUs: "Tell us more about how you found us",
  howDidYouFindOutAboutSociability: "How did you find out about Sociability?",
  appPermissions: "App Permissions",
  updateYourPermissionsToImproveText:
    "Update your permissions to improve your experience using the Sociability App.",
  flagIncorrectPhoto: "Flag incorrect photo",
  milesAway: "miles away",
  photoDescription: "Photo Description",
  returnToApp: "Log in to Sociability",
  locationSettings: "Location Settings",
  exploreYourLocalArea: "Explore your local area",
  turnOnLocationTracking: "Turn on location tracking",
  locationText:
    "Please click continue to open your location settings. Turning on your location will allow us to show your location on the map, and to show you nearby venues that meet your accessibility needs! You can always update your settings in the future.",
  updatedBySociability: "Updated by Sociability",
  mapperEditedHeader:
    "Our mapping team has updated the details for this venue. You can no longer edit your tags.",
  reportMapperTags:
    "You can still let us know if there has been any recent changes by clicking the button below",
  reportARecentChange: "Report a recent change",
  loggedInSuccessfully: "Successfully logged in",
  categoryNotFound: "Category not found",
  pleaseSelectATeamToShare: "Please select a team to share",
  openEmailApp: "Open email app",
  openLocationSettings: "Open location settings",
  exit: "Exit",
  openSettings: "Open Settings",
  areYouSureYouWantToRemoveThisPhotoFromYourUpload:
    "Are you sure you want to remove this photo from your upload? you will lose any alt text added.",
  yourAccessibilityProfileCaps: "Your Accessibility Profile",
  personaliseYourExp:
    "Personalise your experience and join the Sociability community.",
  loginToCustomizeExperience:
    "Log in to customise your experience. You can update your profile, set accessibility preferences, and control your privacy and notifications. ",
  mySavedPlacesCaps: "My Saved Places",
  startBuildingSpots:
    "Start building your collection of favourite accessible spots!",
  startBuildingSpots2:
    "By logging in, you can start saving and organising your favourite accessible spots. Build a list tailored to your needs and preferences.",
  loginToStart: "Login to start",
  venueDetails: "Venue Details",
  chooseSection: "Choose a section",
  sections: "Sections",
  areas: "Areas",
  previousPhoto: "Previous Photo",
  atLeast5CharactersRequired:
    "At least 5 characters required for photo description",
  verifyEmailAddress: "Verify Email Address",
  ok: "Ok",
  yes: "Yes",
  tagging: "Tagging",
  exploreYourFavoriteAccessibleSpots:
    "Explore your favourite accessible spots, create new lists or add new discoveries.",
  yourCuratedCollection: "Your curated collection of accessible places",
  reviewMustBeAtLeast5Characters: "Review must be at least 5 characters",
  helpUsImproveAccessibility: "Help us improve accessibility:",
  name: "Name",
  joinOrCreateTeam: "Join or create a team",
  inviteFriends:
    "Invite your friends and compete against others to tag and review the most venues.",
  teamName: "Team name",
  teams: "Teams",
  sendInvite: "Send invite",
  greatTeamsStartHere:
    "Great teams start here! Invite friends to join and see what you can accomplish together",
  createOrJoinTeamDetails:
    "Create or join teams to collaborate, compete, and discover more venues together.",
  teamSettings: "Team settings",
  yourFeedbackHelps: "Your feedback helps others in our community.",
  wasThisVenueAccessibleForYou: "Was this venue accessible for you?",
  describeYourExperience: "Describe your experience",
  shareYourExperience:
    "Share your experience! Your photos help others get a better sense of the venue.",
  haveYouSpottedSomethingWrong:
    "Have you spotted something wrong? Let us know below and add pictures to help us improve this venue.",
  flagVenue: "Flag venue",
  submitFlag: "Submit flag",
  flagReview: "Flag review",
  flagPhoto: "Flag photo",
  verifyEmailAddress: "Verify Email Address",
  savedPlacesText:
    "Tap 'Explore nearby' to find accessible places around you. When viewing a venue, use the 'Save' button to create or add it to your list.",
  exploreNearBy: "Explore nearby",
  backToVenueDetails: "Back to venue details",
  discoverMoreVenues: "Discover more venues",
  discoverMoreVenuesMessage:
    "Great start, now explore more venues to build your personal accessible guide.",
  savedPlacesListEmpty: "Your list is currently empty",
  savedPlacesListEmptyMessage:
    "Tap 'Explore nearby' to discover accessible venues. Use the 'Save' button when viewing a place to add it to this list.",
  exploreNearby: "Explore nearby",
  exploreNearbyTip:
    "Tip: Use the 'Save' button when viewing a venue to add it to your list.",
  listDescription: "Your curated collection of accessible places",
  startBuildingYourCollection:
    "Start building your collection of favourite accessible spots!",
  youHaventSearchedForAnyPlacseYetDescription:
    "Saving accessible places helps you plan outings more easily and share recommendations with friends. Create a personalised guide to your favourite accessible spots around town.",
  youNeedToLogin: "You need to login to create and view your lists",
  youNeedToLoginDescription:
    "Create personalised lists of accessible venues and share recommendations with the Sociability community. Find and save places that match your specific needs and preferences.",
  openInNewTab: "Open in new tab",
  noAccessibilityInformation: "No accessibility information",
  flagArea: "Flag Area",
  describeYourThought: "Describe your thought",
  submitFlag: "Submit Flag",
  personalDetails: "Personal details",
  loctionSettingsRequired: "Loction settings required",
  loctionSettingsRequiredMessage:
    "Please enable location services to find your location and discover",
  describeYourExperience: "Describe your experience",
  flagAccessibility: "Flag Accessibility",
  haveYouSpottedSomethingWrong:
    "Have you spotted something wrong? Let us know below and add pictures to help us improve this venue.",
  flagPhoto: "Flag Photo",
  flagReview: "Flag Review",
  tellUsWhatIsIncorrect: "Tell us what's incorrect",
  yourFeedbackHelpCommunity: "Your feedback helps others in our community.",
  wasThisVenueAccessibleForYou: "Was this venue accessible for you?",
  submitMapperNotes: "Submit Mapper Notes",
  youUseOrExperienceTheFollowing: "You use or experience the following:",
  exitApp: "Exit App",
  areYouSureYouWantToExit: "Are you sure you want to exit?",
  previous: "Previous",
  additionalAreas: "Additional Areas",
  startExploring: "Start Exploring",
  applySavedFiltersText:
    "You can quickly apply your saved filters with the toggle. Saved filters can be updated in ",
  noUserActivity:
    "This user currently has no activity or has set their profile to private.",
  noCurrentUserActivity:
    "Your adventure awaits! You don't have any recent activity yet. Start exploring to fill this page with your exciting discoveries and achievements.",
  fewSearchResults:
    "We found a few options, but there might be more. Try refining your search or adjusting your filters to discover additional venues.",
  keepExploring: "Keep exploring!",
  editFilters: "Edit filters",
  oopsNoVenuesFound: "Oops! No venues found",
  noSearchResultsHelpText:
    "We couldn't find any venues. Try checking your spelling, use alternative terms, adjusting filters, or widening your search area. ",
  onlyTeamOwnerCanChangePhoto: "Only the team owner can change the cover photo",
  reportUserBehaviour: "Report user behaviour",
  reportUserHelpText:
    "Help keep our community safe by reporting inappropriate behaviour. Our moderation team will review. ",
  reportUserHint:
    "Describe the issue with this user in detail. Include any relevant information that can help us investigate.",
  submitFlag: "Submit flag",
  blockUserHelpText:
    "Blocking this user will prevent them from interacting with you or seeing your content. ",
  guides: "Guides",
  closeMenu: "Close menu",
  whatAccessibilityFeatures: "What accessibility features do you prefer?",
  whatAccessibilityFeaturesSelect:
    "Select all that apply. Change these anytime in your user profile",
  leave: "Leave",
  chooseAnAreaToTag:
    "Choose an area. Once the main area is completed, you can add information to other areas.",
  addANewSpace: "Add a new space",
  addANewSpaceText:
    "Create a space. Once the space is completed, you can add information to other spaces.",
  addANewSpaceDetails:
    "Get started by adding your first space. Once you create a space, you'll be able to add detailed information",
  createSpace: "Create space",
  viewSpace: "View space",
  editSpace: "Edit space",
  duplicateSpace: "Duplicate space",
  listSettings: "List settings",
  generalInfo: "General info",
  spaces: "Spaces",
  floor: "Floor",
  visibility: "Visibility",
  addTags: "Add tags",
  selectFloor: "Select floor",
  selectVisibility: "Select visibility",
  connectedSpaces: "Connected spaces",
  duplicateSpace: "Duplicate space",
  areYouSureYouWantToDuplicateThisSpace:
    "Are you sure you want to duplicate this space?",
  duplicate: "Duplicate",
  deleteSpace: "Delete space",
  thisSpaceWillBePermanentlyDeleted:
    "Click 'Delete' to permanently remove the space and can't be undone. Click 'Cancel' to stop this action.",
  generalInfo: "General info",
  assignTagsInfo:
    "Is there anything that needs to be updated? Make sure all the accessibility information is accurate and up-to-date.",
  visible: "Visible",
  spaceName: "Space name",
  notes: "Notes",
  editInformation: "Edit information",
  addInformation: "Add information",
  addInfo: "Add info",
  deleteSelectedPhotos: "Delete selected photos",
  areYouSureYouWantToDeleteThisSpace:
    "Are you sure you want to delete this space?",
  skipTags: "Skip tags",
  taggingFinishedText: "Great work, your photos and tags have been added.",
  whatWouldYouLikeToDoNext: "What would you like to do next?",
  taggingFinished: "Tagging finished",
  searchSpaces: "Search spaces",
  addNewSpace: "Add new space",
  duplicateSpaces: "Duplicate spaces",
  spaceNameAlreadyTaken: "Please enter a different space name",
  unsavedTags: "Unsaved tags",
  unsavedPhotos: "Unsaved photos",
  accessibilityInformation: "Accessibility information",
  youReachedLimit: "You reached the limit to duplicate at once",
  editTags: "Edit tags",
  leaveUnsavedPhotos: "Leave photo edits?",
  leaveUnsavedPhotosMessage:
    "You have unsaved changes to your photos. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  deleteComplexPhotoText:
    "Click 'Delete' to permanently remove this photo and can't be undone. Click 'Cancel' to stop this action.",
  clickSaveToUpdatePhotos: "Click 'Save photos' to update highlighted photos.",
  continueUnsavedEdits: "Continue unsaved edits?",
  deleteSelectedPhotosText:
    "Click 'Delete' to permanently remove the selected photos and can't be undone. Click 'Cancel' to stop this action.",
  deleteAllPhotos: "Delete all photos?",
  deleteAllPhotosText:
    "Click 'Delete' to permanently remove the all photos and restart photo upload. Click 'Cancel' to stop this action.",
  leaveUnsavedTags: "Leave tag edits?",
  leaveUnsavedTagsMessage:
    "You have unsaved changes to your tags. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  uploadPhotosForCurrentSpace: "Upload photos for current space",
  assignTagsForCurrentSpace: "Assign tags for current space",
  saveSpace: "Save space",
  advancedFilters: "Advanced filters",
  space: "Space",
  discardChanges: "Discard space details edits?",
  discardChangesMessage:
    "You have unsaved changes to your space details. Click 'Discard' to permanently delete all unsaved edits, or click 'Keep editing' to continue making changes.",
  discard: "Discard",
  keepEditing: "Keep editing",
  spaceDetails: "Space details",
  previousTags: "Previous tags",
  taggingStatus: "Tagging status",
  addSpaceDetails: "Add space details",
  returnOnDate: "Return on date",
  returnToVenue: "Return to venue",
  updateComplexTagsDesc:
    "Answer each question to add accessibility information to this venue for other users. Use your photos to help jog your memory. ",
  editSpaceDetails: "Edit space details",
  viewSpaceDetails: "View space details",
  leaveSpaceDetailsEdits: "Leave space details edits?",
  leaveSpaceDetailsEditsMessage:
    "You have unsaved changes to your space details. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  stay: "Stay",
  noSpacesFound: "No spaces found",
  noSpacesFoundText: "We couldn't find any spaces matching your search. Try checking your spelling, using different keywords, or adjusting your filters.",
  remarks: "Remarks",
  spaceAction: "Space action",
  saveNote: "Save note",
  shareYourInsightsToHelp: "Share your insights to help the team. ",
  selectOneThatApply: "Select one that apply",
  doesTheNoteApplyToWholeVenue: "Does the note apply to the whole venue",
  addNotesHere: "Add notes here",
  selectLocation: "Select location",
  noteLocation: "Note location",
  createNewTask: "Create new task",
  taskName: "Task name",
  applyNoteLocation: "Apply note location",
  discardNoteLocations: "Discard note locations?",
  discardNoteLocationsMessage: "You have unsaved changes to your note locations. Click ‘Discard’ to permanently delete all unsaved edits, or click ‘Keep editing’ to continue making changes.",
  wholeVenue: "Whole venue",
  selectNoteLocation: "Select note location",
  searchLocation: "Search location",
  searchFloors: "Search floors",
  updateNote: "Update note",
  connectedSpace: "Connected space",
  applyConnectedSpace: "Apply connected space",
  discardConnectedSpaces: "Discard connected spaces?",
  discardConnectedSpacesMessage: "You have unsaved changes to your connected spaces. Click ‘Discard’ to permanently delete all unsaved edits, or click ‘Keep editing’ to continue making changes.",
  noSpaces: "No spaces",
  noMatchingSpaces: "No matching spaces",
  addSpace: "Add space",
  noResultsFound: "No results found",
  noResultsFoundText: "We couldn't find any results matching your search. Try checking your spelling, using different keywords, or adjusting your filters.",
  newList: "New list",
  profile: "Profile",
  manageAccount: "Manage account",
  badges: "Badges",
  activity: "Activity",
  team: "Team",
  appAccessibility: "App accessibility",
  devicePermissions: "Device permissions",
  settings: "Settings",
  about: "About",
  aboutSociability: "About Sociability",
  whatsNew: "What's new",
  helpAndSupport: "Help and support",
  legal: "Legal",
  levelsAndBadges: "Levels & Badges",
  level: "Level",
  points: "Points",
  streak: "Streak",
  options: "Options",
  transportFitlers: "Transport filters",
  stations: "Stations",
  vehicles: "Vehicles",
  currentUserLocation: "Current user location",
  areYouSureYouWantToResolveThisNote: "Click ‘Resolve’ to confirm that this note is complete and remove it permanently. Click ‘Cancel’ to keep the note.",
  resolveNoteButton: "Resolve",
  mapperNote: "Mapper note",
  noteOnlyVisibleToTeam: "This note will only be visible to team",
  noteVisibleoAll: "This note will be visible to all",
  publicNote: "Public note",
  floor: "Floor",
  area: "Area",
  whatAreaIsTheNoteFor: "What area is the note for?",
  howEssentialIsThisNote: "How essential is this note?",
  selectPriorityLevel: "Select priority level",
  scheduleDateRange: "Schedule date range",
  leaveUntilBlankToKeepPermanently: "Leave until blank to keep permanently",
  fromDate: "From date",
  toDate: "To date",
  untillDate: "Until date",
  venueNote: "Public note",
  whatIsTheStatusOrIssueWithThisVenue: "What is the status or issue with this venue?",
  priorityLevels: "Priority levels",
  doesTheNoteApplyToTheWholeVenue: "Does the note apply to the whole venue?",
  doesTheNoteHaveAnEndDate: "Does the note have an end date?",
  shareYourInsightsToHelpMapper: "Share your insights to help the team. Describe any important information about the venue below.",
  dateRange: "Date range",
  noNotes: "No notes for this venue yet",
  noNotesDescription: "Tap “Add mapper note” to be the first to share accessibility insights! Your knowledge helps others explore.",
  deleteNote: "Delete note",
  deleteNoteMessage:
    "Are you sure you want to delete this note? This action cannot be undone.",
   noteUpdatedSuccessfully: "Note updated successfully",
   noteCreatedSuccessfully: "Note created successfully",
   resolveNote: "Resolve note",
   resolveNoteMessage: "Are you sure you want to resolve this note?",
   resolve: "Resolve",
   doYouWantToScheduleThisNote: "Do you want to schedule this note for specific dates?",
   noMapperNotes: "No mapper notes for this venue yet",
   noMapperNotesDescription: "Tap 'Add note' to record important information about the venue and keep the rest of the team up to date.",
   flagVenueNote: "Flag public note",
   flagVenueNoteMessage: "Have you spotted something wrong? Let us know below and add pictures to help us improve this venue.",
   selectStatus: "Select status",
   statusExplained: "Status explained",
   createNote: "Create note",
   thisWillBeOnlyVisibleToTheTeam: "This will be only visible to the team",
   thisNoteWillBeVisibleToEveryone: "This note will be visible to everyone",
   selectArea: "Select area",
   editNote: "Edit note",
   addNoteHeadline: "Add note headline",
   viewNoteDetails: "View note details",
   levelsExplained: "Levels explained",
   location: "Location",
   noteFor: "Note for",
   addNoteHere: "Add note here",
   selectNotePriority: "Select note priority",
   selectNoteStatus: "Select note status",
   viewAnnouncementDetails: "View announcement details",
   announcements: "Announcements",
   announcementTitle: "Announcement",
   note: "Note",
   allNotes: "All notes",
   photo: "Photo",
   spaceList: "Space list",
   downloadPhoto: "Download photo",
   noNearByVenuesInThisCategory: "No nearby venues in this category",
   tryUpdateCategoryFilters: "Try changing the category or click below to view all nearby venues",
   viewAllNearbyVenues: "View all",
   makeVenueVisibleToMappersUntil: "Make venue not visible to mappers until",
   searchNearbyVenues: "Search nearby venues",
}

const es = {
  welcome: "Hola",
};

const ja = {
  welcome: "Konnichiwa",
};

const de = {
  appName: "Socialbility",
  welcome: "Hallo",
  continue: "Fortsetzen",
  default: "Default (Paragraph Small Regular Text)",
  h1Large: "H1 Large Text",
  h1Medium: "H1 Medium Text",
  h1Small: "H1 Small Text",
  h1XSmallExtraBold: "H1 XSmall Extra Bold Text",
  h1XSmallBold: "H1 XSmall Bold Text",
  h2LargeBold: "H2 Large Bold Text",
  h2LargeSemiBold: "H2 Large SemiBold Text",
  h2MediumBold: "H2 Medium Bold Text",
  h2MediumSemiBold: "H2 Medium SemiBold Text",
  h2SmallBold: "H2 Small Bold Text",
  h2SmallSemiBold: "H2 Small SemiBold Text",
  h3Large: "H3 Large Text",
  h3Small: "H3 Small Text",
  h3XSmall: "H3 XSmall Text",
  h4Large: "H4 Large Text",
  h4SmallSemiBold: "H4 Small SemiBold Text",
  h4SmallMedium: "H4 Small Medium Text",
  paragraphXSmallMedium: "Paragraph XSmall Medium Text",
  paragraphSmallRegular: "Paragraph Small Regular Text",
  paragraphSmallMedium: "Paragraph Small Medium Text",
  paragraphMediumRegular: "Paragraph Medium Regular Text",
  paragraphMediumSemiBold: "Paragraph Medium SemiBold Text",
  loginOrCreateAccount: "Einloggen oder Konto erstellen",
  or: "oder",
  continueWithGoogle: "Mit Google fortfahren",
  continueWithFacebook: "Mit Facebook fortfahren",
  login: "Einloggen",
  forgotYourPassword: "Passwort vergessen?",
  alreadyHaveAnAccount: "Haben Sie bereits ein Konto?",
  createAccount: "Konto erstellen",
  yourPasswordShouldContain: "Ihr Passwort sollte enthalten:",
  atleast6Characters: "Mindestens 6 Zeichen",
  atleast1NumberOrUppercaseLetter: "1 Symbol oder Zahl",
  agreeAndContinue: "Zustimmen und fortfahren",
  saveAndContinue: "Speichern und fortfahren",
  howWillYouUseSociability: "Wie werden Sie Sociability nutzen?",
  helpUsImproveYourExperience: "Helfen Sie uns, Ihre Erfahrung zu verbessern!",
  chooseOne: "Wählen Sie eines aus",
  back: "Zurück",
  howDidYouFindOutAboutSociability: "Wie haben Sie von Sociability erfahren?",
  selectAllThatApply: "Wählen Sie alle zutreffenden Optionen.",
  createYourAccessibilityProfile: "Erstellen Sie Ihr Zugänglichkeitsprofil",
  findThePlacesThatWorkForYou: "Finden Sie Orte, die für Sie geeignet sind!",
  doYouWantToMakeYourDisabilityVisibleToTheSociabilityCommunity:
    "Möchten Sie Ihre Behinderung in der Sociability-Community sichtbar machen?",
  makeDisabilityVisible: "Behinderung sichtbar machen?",
  youCanChangeThisAnytimeInYourAccountSettings:
    "Sie können dies jederzeit in Ihren Kontoeinstellungen ändern",
  whatAccessibilityFeaturesDoYouRequire:
    "Welche Zugänglichkeitsfunktionen bevorzugen Sie?",
  areAnyOfTheseSuitable: "Sind irgendwelche davon geeignet?",
  letsVerifyYourEmailAddress: "Lassen Sie uns Ihre E-Mail-Adresse überprüfen",
  weJustNeedToCheckTtsReallyYou:
    "Wir müssen nur überprüfen, ob Sie es wirklich sind:",
  wehaveJustSentAnEmailTo: "Wir haben gerade eine E-Mail gesendet an:",
  clickTheLinkInsideToLogInToSociability:
    "Klicken Sie auf den Link in der E-Mail, um sich bei Sociability anzumelden!",
  returnToLoginPage: "Zurück zur Anmeldeseite",
  getInTouch: "Kontakt aufnehmen",
  letUsKnowYourFeedback: "Lassen Sie uns Ihr Feedback wissen:",
  send: "Senden",
  addPhotos: "Fotos hinzufügen",
  addPhoto: "Foto hinzufügen",
  exitMenu: "Menü verlassen",
  preferences: "Einstellungen",
  yourProfile: "Ihr Konto",
  locationPreferences: "Standorteinstellungen",
  yourAccessibilityProfile: "Ihr Zugänglichkeitsprofil",
  accessibilityFeatures: "Zugänglichkeitsfunktionen",
  appAccessibility: "App-Zugänglichkeit",
  deviceSettings: "Geräteeinstellungen",
  helpSupport: "Hilfe & Unterstützung",
  howTheAppWorks: "Wie die App funktioniert",
  taggingInformation: "Informationen markieren",
  faqs: "FAQs",
  aboutSociability: "Über Sociability",
  appFeedback: "App-Feedback",
  finePrint: "Kleingedrucktes",
  privacyPolicy: "Datenschutzrichtlinie",
  termsOfUse: "Nutzungsbedingungen",
  logOut: "Abmelden",
  resetPassword: "Passwort zurücksetzen",
  enterYourNewPasswordAndConfirmItBelow:
    "Geben Sie Ihr neues Passwort ein und bestätigen Sie es unten",
  doYouOrSomeoneYouKnowHaveAnyAccessibilityRequirements:
    "Haben Sie oder jemand, den Sie kennen, spezielle Zugänglichkeitsanforderungen?",
  skipForNow: "Für jetzt überspringen",
  tellUsABitAboutYourself: "Erzählen Sie uns ein wenig über sich",
  doYouOrSomeoneYouKnowExperienceOrUseAnyOfTheFollowing:
    "Haben Sie oder jemand, den Sie kennen, Erfahrungen mit einem der folgenden Punkte?",
  shareYourAccessibilityProfile: "Teilen Sie Ihr Zugänglichkeitsprofil",
  tellTheCommunityABitMoreAboutYourself:
    "Erzählen Sie der Community ein wenig mehr über sich.",
  helpOtherUsersBetterUnderstandYourReviews:
    "Helfen Sie anderen Benutzern, Ihre Bewertungen besser zu verstehen.",
  setYourPreferredFilters: "Legen Sie Ihre bevorzugten Filter fest.",
  selectAllThatApply2:
    "Wählen Sie alle zutreffenden Optionen. Ändern Sie diese jederzeit in Ihrem Benutzerprofil.",
  wouldAnyOfTheseAlsoWork: "Würden einige davon auch funktionieren?",
  cancel: "Abbrechen",
  close: "Schließen",
  takePhoto: "Foto machen",
  fromPhotos: "Aus Fotos",
  termsAndConditions: "Geschäftsbedingungen",
  byClickingAgree:
    "Indem Sie zustimmen und fortfahren, bestätige ich, dass ich die folgenden Bedingungen gelesen, verstanden und akzeptiert habe:",
  reviewOnboarding: "Überprüfung des Onboardings",
  searchVenueOrLocation: "Veranstaltungsort oder Ort suchen",
  showNearBy: "In der Nähe anzeigen",
  filters: "Filter",
  listview: "Listenansicht",
  finish: "Beenden",
  venueTypes: "Veranstaltungstypen",
  openingHours: "Öffnungszeiten",
  search: "Suchen",
  clearAll: "Alle löschen",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  youAreInTaggingMode: "Sie sind im Markierungsmodus!",
  taggingModeDescription1:
    "Sie können jetzt nur noch Orte ohne Zugänglichkeitsinformationen sehen.",
  taggingModeDescription2:
    "Fahren Sie fort, die Zugänglichkeit neuer Veranstaltungsorte zu markieren, oder kehren Sie zur Erkundung von Veranstaltungsorten zurück.",
  gotItLetsTag: "Verstanden. Lassen Sie uns markieren!",
  switchBackToExploring: "Zurück zum Erkunden von Veranstaltungsorten wechseln",
  youAreInExploregMode: "Sie sind im Erkundungsmodus!",
  homeModeDescription1:
    "Sie können jetzt alle Veranstaltungsorte sehen - mit und ohne Zugänglichkeitsinformationen.",
  homeModeDescription2:
    "Fahren Sie fort, neue Veranstaltungsorte zu erkunden, oder kehren Sie zum Markieren von Veranstaltungsorten zurück.",
  gotItLetsExplore: "Verstanden. Lassen Sie uns erkunden!",
  switchBackToTagging: "Zurück zum Markieren wechseln",
  accessibilityOverview: "Überblick über die Zugänglichkeit",
  completedSections: "Abgeschlossene Abschnitte",
  addAccessibilityInfo: "Zugänglichkeitsinformationen hinzufügen",
  viewAllInformation: "Alle Informationen anzeigen",
  isSomethingNotRight: "Stimmt etwas nicht?",
  reportAnErrorOrUpdate: "Einen Fehler melden oder aktualisieren",
  sortBy: "Sortieren nach",
  photos: "Fotos",
  reviews: "Bewertungen",
  addReview: "Bewertung hinzufügen",
  addAccessibilityInformation: "Zugänglichkeitsinformationen hinzufügen",
  addAReview: "Eine Bewertung hinzufügen",
  thisVenueIsLookingBare: "Dieser Ort sieht kahl aus...",
  addPhotosAndTagsToShare:
    "Fügen Sie Fotos und Tags hinzu, um Zugänglichkeitsinformationen mit anderen zu teilen!",
  mapperNotes: "Kartierungsnotizen",
  tellOtherMappersAbout:
    "Erzählen Sie anderen Kartierern von Ihrer Erfahrung an diesem Ort",
  submit: "Einreichen",
  leaveReview: "Bewertung hinterlassen",
  didThisVenueSuitYourNeeds: "Entsprach dieser Ort Ihren Anforderungen?",
  howWasYourVisitToThisVenue: "Wie war Ihr Besuch an diesem Ort?",
  post: "Posten",
  whatIsThisPhotoOf: "Worum handelt es sich bei diesem Foto?",
  brieflyDescribeThisPhoto:
    "Beschreiben Sie dieses Foto kurz für diejenigen, die es möglicherweise nicht sehen können. Mindestens 5 Zeichen sind erforderlich.",
  yes: "Ja",
  no: "Nein",
  describeWhatThisImageShows:
    "Beschreiben Sie, was dieses Bild zeigt, um unseren blinden Benutzern zu helfen.",
  pleaseSelectOneOfTheTags: "Bitte wählen Sie einen der Tags aus.",
  adddMorePhotos: "Mehr Fotos hinzufügen",
  upload: "Hochladen",
  areYouSureYouWantToRemoveThisPhotoFromYourUpload:
    "Sind Sie sicher, dass Sie dieses Foto aus Ihrem Upload entfernen möchten? Sie verlieren jeglichen hinzugefügten Alt-Text.",
  removePhoto: "Foto entfernen?",
  wereSorryThisVenueHasNoReviews:
    "Es tut uns leid! Dieser Ort hat noch keine Bewertungen. Fangen Sie jetzt an, indem Sie eine hinzufügen!",
  photosUploadedSuccessfully: "Fotos erfolgreich hochgeladen!",
  reviewUploadedSuccessfully: "Bewertung erfolgreich hochgeladen!",
  startTagging: "Beginnen Sie mit dem Tagging!",
  pickACategory:
    "Wählen Sie eine Kategorie, um Zugänglichkeitsinformationen hinzuzufügen. Sie müssen einige Fotos vom Ort machen und einige Fragen beantworten.",
  finishTagging: "Tagging beenden",
  pickAnAreaToTag: "Wählen Sie einen Bereich zum Markieren aus",
  pickAnAreaToTagLong:
    "Wählen Sie einen Bereich des Veranstaltungsortes zum Markieren aus! Sie müssen mit dem Haupteingang beginnen, danach können Sie jeden anderen Bereich wählen.",
  locked: "Gesperrt",
  editInformation: "Informationen bearbeiten",
  gettingStarted: "Erste Schritte",
  dontShowThisAgain: "Dies nicht mehr anzeigen",
  uploadPhotosFromYourGallery:
    "Laden Sie Fotos aus Ihrer Galerie hoch oder machen Sie jetzt neue.",
  uploadPhotos: "Fotos hochladen",
  thenAddShortDescription:
    "Fügen Sie dann eine kurze Beschreibung jedes Fotos für unsere sehbehinderten Benutzer hinzu.",
  describeThisPhoto: "Beschreiben Sie dieses Foto",
  brieflyDescribeThisPhotoYouHaveAdded:
    "Beschreiben Sie jedes hinzugefügte Foto kurz für unsere sehbehinderten oder blinden Benutzer.",
  thisIsAPhotoOf: "Dies ist ein Foto von....",
  describeThisPhotoForOurBlindUsers:
    "Beschreiben Sie dieses Foto für diejenigen, die es möglicherweise nicht sehen können. Mindestens 5 Zeichen sind erforderlich.",
  exit: "Beenden",
  nextPhoto: "Nächstes Foto",
  photosAdded: "Fotos hinzugefügt!",
  managePhotos: "Fotos verwalten",
  toViewSimplyTap:
    "Zum Ansehen einfach antippen. Wenn Sie die Reihenfolge ändern möchten, ziehen Sie einfach die Fotos. Oder Sie können weitere Fotos hinzufügen, wenn Sie möchten. Sie müssen mindestens ein Foto hochladen.",
  next: "Weiter",
  assignTags: "Tags zuweisen",
  answerEachQuestionToTag:
    "Beantworten Sie jede Frage, um diesen Veranstaltungsort für andere Benutzer zu markieren! Nutzen Sie Ihre Fotos, um Ihr Gedächtnis aufzufrischen.",
  areYouSure: "Sind Sie sicher?",
  ifYouLeaveThisScreenYouWillLose:
    "Wenn Sie diesen Bildschirm verlassen, verlieren Sie Ihre aktuellen Fotos. Klicken Sie auf Beenden, um neu zu beginnen, oder auf Fortsetzen, um Ihre aktuellen Fotos zu behalten.",
  deletePhoto: "Foto löschen",
  areYouSureYouWantToDeleteThisPhoto:
    "Sind Sie sicher, dass Sie dieses Foto löschen möchten? Es wird Änderungen am Veranstaltungsort vornehmen.",
  selectAllApply: "Alle zutreffenden Optionen auswählen",
  chooseOneAnswer: "Eine Antwort auswählen",
  areYouSureYouWantToStopTagging:
    "Sind Sie sicher, dass Sie mit dem Tagging aufhören möchten?",
  yourProgressWillBeSavedAndYouCanReturn:
    "Ihr Fortschritt wird gespeichert, und Sie können später zurückkehren, um den Bereich fertigzustellen.",
  pleaseCompleteAllRequiredQuestions:
    "* Bitte vervollständigen Sie alle erforderlichen Fragen.",
  error: "Fehler",
  userNotLoggedIn: "Benutzer nicht eingeloggt",
  updateTags: "Tags aktualisieren",
  isThereAnythingThatNeedsToBeUpdated:
    "Gibt es etwas, das aktualisiert werden muss? Stellen Sie sicher, dass alle Zugänglichkeitsinformationen genau und aktuell sind.",
  editPhotos: "Fotos bearbeiten",
  thanksForCheckingTags:
    "Danke für die Aktualisierung Ihrer Tags! Möchten Sie auch Ihre Fotos überprüfen, um sicherzustellen, dass sie übereinstimmen?",
  ItsImportantToEnsureThatYourPhotosAreAccurate:
    "Es ist wichtig, sicherzustellen, dass die Fotos mit den Tags übereinstimmen, damit unsere Informationen für andere Benutzer so genau wie möglich sind.",
  reviewPhotos: "Fotos überprüfen",
  savePhotos: "Fotos speichern",
  areYouSureYouWantToUpdateAccessibility:
    "Sind Sie sicher, dass Sie die Zugänglichkeitsinformationen aktualisieren möchten? Es wird Änderungen am Veranstaltungsort vornehmen.",
  photoGuide: "Foto-Leitfaden",
  doYouWantToAddAddionalVSHInformation:
    "Möchten Sie zusätzliche visuelle, sensorische und hörbezogene Fotos hinzufügen?",
  deleteInformation: "Informationen löschen",
  save: "Speichern",
  photoWillBePermanentlyDeleted:
    "Das Foto wird dauerhaft von diesem Veranstaltungsort entfernt.",
  delete: "Löschen",
  selectPhotos: "Fotos auswählen",
  atleastOnePhotoIsReq:
    "Mindestens ein Foto ist für jeden Bereich erforderlich. Heben Sie die Auswahl mindestens eines Fotos auf, um fortzufahren.",
  deletePhotos: "Fotos löschen",
  photosWillBePermanentlyDeleted:
    "Foto(s) werden dauerhaft von diesem Veranstaltungsort entfernt.",
  photosDeleted: "Fotos gelöscht!",
  taggingInProgress: "Tagging läuft",
  thisAreaHasAlreadyBeenTagged:
    "Dieser Bereich wurde bereits markiert. Fügen Sie einen neuen hinzu!",
  editAccessibilityInformation: "Zugänglichkeitsinformationen bearbeiten",
  settings: "Einstellungen",
  mapperNoteAdded: "Kartierungsnotiz hinzugefügt!",
  noPhotosHaveBeenAddedToThisVenueYet:
    "Diesem Veranstaltungsort wurden noch keine Fotos hinzugefügt. Fangen Sie jetzt an, indem Sie einige hinzufügen!",
  thereAreCurrentlyNoImagesForVSH:
    "Es gibt derzeit keine Bilder für den visuellen, sensorischen und hörbezogenen Bereich. Fügen Sie einige Fotos hinzu oder klicken Sie auf Speichern, um die Bearbeitung zu beenden.",
  thisAreaIsLocked: "Dieser Bereich ist gesperrt!",
  reviewSavedSuccessfully: "Bewertung erfolgreich gespeichert",
  addImage: "Bild hinzufügen",
  inviteYourFriendsToJoinYourTeam:
    "Laden Sie Ihre Freunde ein, Ihrem Team beizutreten und gegen andere zu konkurrieren, um die meisten Veranstaltungsorte zu markieren!",
  myTeams: "Meine Teams",
  shareInviteFriends: "Teilen & Freunde einladen",
  shareTheSociabilityApp: "Die Sociability-App teilen",
  askYourFriendToScan:
    "Bitten Sie Ihren Freund, diesen QR-Code zu scannen oder per E-Mail oder Text zu teilen",
  shareViaEmailOrText: "Per E-Mail oder Text teilen",
  shareUserProfile: "Benutzerprofil teilen",
  inviteYourFriendsToJoinYourTeam2: "Freunde in Ihr Team einladen",
  selectATeam: "Ein Team auswählen",
  createTeam: "Team erstellen",
  yourTeamName: "Ihr Teamname",
  enterYourTeamName: "Geben Sie Ihren Teamnamen ein",
  create: "Erstellen",
  teamMembers: "Teammitglieder",
  addNewMember: "Neues Mitglied hinzufügen",
  noTeamMembers: "Keine Teammitglieder",
  addNewMembersToYourTeamBy: "Fügen Sie Ihrem Team ein neues Mitglied hinzu",
  renameTeam: "Team umbenennen",
  updateCoverPhoto: "Titelbild aktualisieren",
  deleteTeam: "Team löschen",
  areYouSureYouWantToDeleteThisTeam:
    "Sind Sie sicher, dass Sie dieses Team löschen möchten?",
  addTeamMember: "Teammitglied hinzufügen",
  askYourFriendToScanThis:
    "Bitten Sie Ihren Freund, diesen QR-Code zu scannen oder per E-Mail oder Text zu senden.",
  viewProfile: "Profil ansehen",
  removeUser: "Teammitglied entfernen",
  teamMemberProfileSetToPrivate: "Teammitgliedprofil auf privat gesetzt",
  removeMember: "Mitglied entfernen",
  areYouSureYouWantToRemoveThisMember:
    "Sind Sie sicher, dass Sie dieses Mitglied entfernen möchten?",
  flagUser: "Benutzer melden",
  blockUser: "Benutzer blockieren",
  reportAnIssueWithAnotherUser: "Ein Problem mit einem anderen Benutzer melden",
  desribeTheIssueWithThisUserAndAddScreenshots:
    "Beschreiben Sie das Problem mit diesem Benutzer und fügen Sie Screenshots hinzu, die Ihre Informationen erklären könnten.",
  share: "Teilen",
  editReview: "Bewertung bearbeiten",
  editPhotos: "Fotos bearbeiten",
  deleteReview: "Bewertung löschen",
  aSociabilityAdminHasEditedTheseTags:
    "Ein Sociability-Administrator hat diese Tags bearbeitet",
  continueTaggingQuestion: "Weiter taggen?",
  continueTagging: "Weiter taggen",
  iWilldoItLater: "Ich mache es später",
  leaveTeam: "Team verlassen",
  earnPointsByAddingTagsDesc:
    "Punkte verdienen, indem Sie Tags, Bewertungen und Fotos für Veranstaltungsorte hinzufügen. Verdienen Sie spezielle Abzeichen, um einen zusätzlichen Schub zu erhalten, und Sie bewegen sich in der Bestenliste nach oben!",
  areYouSureYouWantToLeaveThisTeam:
    "Sind Sie sicher, dass Sie dieses Team verlassen möchten?",
  explore: "Erkunden",
  mySavedPlaces: "Meine gespeicherten Orte",
  basicInfo: "Grundlegende Informationen",
  fullName: "Vollständiger Name",
  edit: "Bearbeiten",
  email: "E-Mail",
  gender: "Geschlecht",
  yearOfBirth: "Geburtsjahr",
  password: "Passwort",
  changePassword: "Passwort ändern",
  privacySettings: "Datenschutzeinstellungen",
  shareYourProfileActivity: "Teilen Sie Ihre Profilaktivität",
  profileVisibility:
    "Machen Sie Ihre Profilaktivität für andere Benutzer sichtbar",
  makeYourDisabilityVisibleInreviews:
    "Machen Sie Ihre Behinderung in den Veranstaltungsbewertungen sichtbar",
  yourAccessibilityProfile: "Ihr Zugänglichkeitsprofil",
  yourAccessRequirements: "Ihre Zugänglichkeitsanforderungen",
  yourSavedFilters: "Ihre gespeicherten Filter",
  updateProfile: "Profil aktualisieren",
  update: "Aktualisieren",
  saveChanges: "Änderungen speichern",
  emailAndPassword: "E-Mail & Passwort",
  filtersWillDisplayVenuesWithYour:
    "Filter werden Veranstaltungsorte mit Ihren bevorzugten Zugänglichkeitsfunktionen anzeigen.",
  account: "Konto",
  deleteYourAccount: "Ihr Konto löschen",
  yourAccountWillBeDeleted:
    "Ihr Konto wird gelöscht, diese Aktion kann nicht rückgängig gemacht werden.",
  chooseAGender: "Wählen Sie ein Geschlecht",
  pickYearOfBirth: "Wählen Sie das Geburtsjahr",
  updatePassword: "Passwort aktualisieren",
  currentPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  confirmPassword: "Passwort bestätigen",
  areYouSureYouWantToDeleteThisAccount:
    "Sind Sie sicher, dass Sie dieses Konto löschen möchten?",
  deleteAccount: "Konto löschen",
  confirmProfilePhoto: "Profilfoto bestätigen",
  enterYourExistingPwd: "Geben Sie Ihr vorhandenes Passwort ein",
  createAStrongPwd: "Erstellen Sie ein starkes Passwort",
  confirmYourNewPwd: "Bestätigen Sie Ihr neues Passwort",
  passwordMatches: "Passwort stimmt überein",
  passwordsDontMatchPleaseTryAgain:
    "Passwörter stimmen nicht überein, bitte versuchen Sie es erneut",
  yourPwdShouldContain: "Ihr Passwort sollte enthalten: ",
  atLeast6Chars: "• Mindestens 6 Zeichen",
  oneSymbolOrNumber: "• Ein Symbol oder eine Zahl",
  closedToday: "Heute geschlossen",
  invalidTime: "Ungültige Zeit",
  accessibilityInformationAvailable: "Zugänglichkeitsinformationen verfügbar",
  noAccessibilityInformationAvailable:
    "Keine Zugänglichkeitsinformationen verfügbar",
  lastUpdated: "Zuletzt aktualisiert",
  allPhotos: "Alle Fotos",
  allReviews: "Alle Bewertungen",
  continueWithApple: "Mit Apple fortfahren",
  makeYourDisabilityPublic: "Machen Sie Ihre Behinderung öffentlich?",
  youCanChangeThisAnytimeInYourUserProfile:
    "Sie können dies jederzeit in Ihrem Benutzerprofil ändern.",
  bySelectingAgreeAndContinue:
    "Indem ich zustimme und fortfahre, bestätige ich, dass ich die folgenden Bedingungen gelesen, verstanden und akzeptiert habe:",
  and: "und",
  privacyNotice: "Datenschutzhinweis",
  loading: "Lädt...",
  downloadApp: "App herunterladen",
  searchForVenue: "Veranstaltungsort suchen",
  typeAVenueNameOrLocation:
    "Geben Sie einen Veranstaltungsortnamen oder -ort ein",
  yourProfile: "Ihr Profil",
  yourActivity: "Ihre Aktivität",
  applySavedAccessibilityFilters: "Gespeicherte Zugänglichkeitsfilter anwenden",
  viewVenues: "Veranstaltungsorte ansehen",
  openNow: "Jetzt geöffnet",
  signInWithApple: "Mit Apple anmelden",
  noResultsFound: "No results found",
  noResultsFoundText: "We couldn't find any results matching your search. Try checking your spelling, using different keywords, or adjusting your filters.",
  bitLostMessageSearch:
    "Looks like we're a bit lost! Try tweaking your search by adding in more details about the venue name, type or address you’re looking for",
  photoGallery: "Photo Gallery",
  dateAddedNewestToOldest: "Date Added (Newest - Oldest)",
  dateAddedOldestToNewest: "Date Added (Oldest - Newest)",
  venueCategory: "Venue Category",
  noPhotosAvailable: "No photos available for this venue",
  thisImageFromGoogleMaps: "This image is taken from Google Maps"
};

export { en, es, ja, de };
